export enum NotifyHrmOrigin {
	SKILL_SEARCH = "SKILL_SEARCH",
	RESOURCE_SEARCH = "RESOURCE_SEARCH",
	INSTANCE_WIDE_SEARCH = "INSTANCE_WIDE_SEARCH",
}
